<template>
    <layout-gestao>
        <LayerDetails :moduleId="moduleCode"/>
    </layout-gestao>
</template>

<script>
    import mixin from '../../mixin'

    export default {
        mixins: [mixin],
        components: {
            LayerDetails: () => import(/* webpackChunkName: "defaultlayers-details" */ '@/app/shared/components/layers/defaultlayers/Details'),
        },
    }
</script>
